<template>
    <div v-if="salesItem">
        <h1>{{ salesItem.name }}</h1>

        <p class="sales-item-reference" @click="selectReferenceId">
            Referens: <span ref="referenceIdEl">{{ referenceId }}</span>
        </p>

        <p v-if="salesItem.description" class="sales-item-description">
            {{ salesItem.description }}
        </p>

        <p>
            <router-link :to="`/store/${storeId}`" class="button">Tillbaka</router-link>
            <router-link :to="`/store/${storeId}/sales_item/edit/${salesItem.id}`" class="button">Redigera</router-link>
            <button @click.prevent="deleteThisItem()">Ta bort</button>
            <LoaderButton @click.prevent="createPart()" :isLoading="isLoadingCreatePart">Skapa del</LoaderButton>
            <template v-if="salesItem.parts.length > 0">
                <LoaderButton @click.prevent="printAllLabels()" :isLoading="isLoadingPrintAll">Skriv ut alla etiketter</LoaderButton>
                <a :href="`${apiUrl}/tradera_stores/${storeId}/sales_items/${salesItem.id}/parts/print`" class="button" target="_blank">Hämta etiketter</a>
            </template>
        </p>

        <SalesItemPartList :salesItem="salesItem" @delete="deletePart" @print="printLabel" :apiUrl="apiUrl" :storeId="storeId"/>
    </div>
    <p v-else class="app-loader">
        Laddar...
    </p>
</template>

<script>
import Hashids from 'hashids'
import salesItems from '../repos/sales-items'
import LoaderButton from '../components/LoaderButton.vue'
import SalesItemPartList from '../components/SalesItemPartList.vue'
import copyToClipboard from '../copyToClipboard'

const hashids = new Hashids();

export default {
    name: 'salesItem',
    components: {
        LoaderButton,
        SalesItemPartList
    },
    data: function () {
        return {
            apiUrl: process.env.VUE_APP_API_URL,
            storeId: null,
            itemId: null,
            isLoadingCreatePart: false,
            isLoadingPrintAll: false
        }
    },
    computed: {
        referenceId() {
            return hashids.encode(this.salesItem.id);
        },
        salesItem() {
            return this.$store.getters['salesItems/getById'](this.itemId);
        }
    },
    methods: {
        selectReferenceId() {
            copyToClipboard(this.$refs.referenceIdEl.textContent);

            let selection = getSelection();
            let range = document.createRange();
            range.selectNodeContents(this.$refs.referenceIdEl);
            selection.removeAllRanges();
            selection.addRange(range);
        },
        deleteThisItem() {
            if (confirm('Är du säker på att du vill ta bort det här objektet?')) {
                this.$store.dispatch('salesItems/delete', this.salesItem.id)
                    .then(() => {
                        this.$router.push(`/store/${this.storeId}`);
                    })
                ;
            }
        },
        createPart() {
            this.isLoadingCreatePart = true;
            salesItems.postPart(this.storeId, this.salesItem.id)
                .then(response => {
                    this.$store.commit('salesItems/itemUpdateSuccess', response.data);
                    this.isLoadingCreatePart = false;
                })
                .catch(() => {
                    this.isLoadingCreatePart = false;
                })
            ;
        },
        deletePart(part_number) {
            salesItems.deletePart(this.storeId, this.salesItem.id, part_number).then(() => {
                let salesItem = {
                    ...this.salesItem
                };

                salesItem.parts = this.salesItem.parts.filter(part => {
                    return (part !== part_number);
                });

                this.$store.commit('salesItems/itemUpdateSuccess', salesItem);
            });
        },
        printLabel(part_number) {
            salesItems.print(this.storeId, this.salesItem.id, part_number);
        },
        printAllLabels() {
            this.isLoadingPrintAll = true;
            salesItems.printAll(this.storeId, this.salesItem.id)
                .then(() => {
                    this.isLoadingPrintAll = false;
                })
                .catch(() => {
                    this.isLoadingPrintAll = false;
                })
            ;
        }
    },
    created() {
        this.$store.dispatch('traderaStores/getAll');
        this.storeId = parseInt(this.$route.params.store_id, 10);
        this.$store.dispatch('salesItems/getAll', this.storeId);
        this.itemId = parseInt(this.$route.params.id, 10);
    },
    watch: {
        '$route'(to) {
            this.storeId = parseInt(to.params.store_id, 10);
            this.itemId = parseInt(to.params.id, 10);
        }
    }
}
</script>
